
<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <!-- -->
              <b-col cols="4">
                <label for="select-empresa-cor">Empresa</label> 
                <multiselect  id="selecao-empresa-cor-ind"  v-model="empresaf" 
                  :options="empresasf" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="nomeempresarial" track-by="nomeempresarial" name="nomeempresarial"
              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-filial_cor">Filial</label> 
                <multiselect id="selecao-filial-coe-ind"  v-model="filialf"
                  :options="filiaisf" 
                  :multiple="true"         
                  @close="loadTipos()"
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>


              <b-col cols="2">
                <label for="select-tpcorretiva-ind">Tipo de corretiva</label> 
                <multiselect  v-model="tipo" 
                  :options="tipos"                   
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione o tipo" label="tipo" track-by="tipo" name="tipo"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final"  placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              
              <!-- condicional para exibir o botão planilha-->
              <b-col cols="1">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2"  @click="loadKpiDia(), loadKpiTipo(), loadKpiFuncionario(),loadKpiCarro(), loadKpiLinha(),loadKpiQtd(),loadKpiResumo(),loadKpiMkbf()">
                   carregar
                </b-button>                      
              </b-col>

          </b-row>
    </b-form>   

    <div>
      <b-row>

        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
        

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="COMBUSTÍVEL"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{  (kpiresumo.reduce((total, item) => total + parseFloat(item.combustivel), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}  
                  </h2>
                </b-card-text>
              </b-card>
        
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="QUILOMETRAGEM PERCORRIDA"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{  (kpiresumo.reduce((total, item) => total + parseFloat(item.km_rodado), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}  
                </h2>
                
                
              </b-card-text>
            </b-card>
        
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="CORRETIVAS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ kpiqtds.length }}
                </h2>
                
              </b-card-text>
      </b-card>        
      
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="CORRETIVAS MKBF"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ kpimkbf.length }}
                </h2>
                
              </b-card-text>
      </b-card>        
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="MKBF  " 
            header-bg-variant="danger"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{ kpimkbf.length > 0 ? (kpiresumo.reduce((total, item) => total + parseFloat(item.km_rodado), 0) / kpimkbf.length).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0.0 }}  
              </h2>
              
            </b-card-text>
          </b-card>
      </b-card-group> 

        

      </b-row>
      
    </div>

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
  

          <b-col cols="6" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>

          <b-col cols="6" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="charttipo"
            height="400" 
            :options="graficoTipoCorretiva" 
            :series="seriestipo"
            >
            </apexcharts>
          </b-col>


        </b-row>

        

        <!-- acumulado  -->
        <b-row>
          
          <!-- acumulado  operador
           -->
          <b-col cols="4">
            <apexcharts
            ref="chartfuncionario" 
            height="400" 
            :options="graficoFuncioanrio" 
            :series="seriesfuncionario"
            ></apexcharts>
          </b-col>

          <!-- acumulado  carro -->
          <b-col cols="4">
            <apexcharts 
            ref="chartcarro"
            height="400" :options="graficoCarro" 
            :series="seriescarro"></apexcharts>
          </b-col>

   


          <!-- acumulado  carro -->
          <b-col cols="4">
            <apexcharts 
            ref="chartlinha"
            height="400" :options="graficoLinha" 
            :series="serieslinha"></apexcharts>
          </b-col>

        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'


export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'area',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false                
              },
              
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Corretivas diárias',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    },
    
  },

  
  /* Tipo de corretiva */
  graficoTipoCorretiva: {
    chart: {
              id: 'bar-tipo',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {
//         colors: generateRandomColors() // Gere cores dinamicamente






        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },    

      categories:[], 
      tickPlacement: 'of'            
    },     
    title: {
      text: 'Tipo de corretivas',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  
/* Operador    */
  graficoFuncioanrio: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 20 por operadores',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


  
/* Operador    */
  graficoCarro: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 20 por carros',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  


  /* Linha */
  graficoLinha: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {        
        horizontal: true,
       // isFunnel: true,        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },    

      categories:[], 
      tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 20 por linhas',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  empresaf:'', 
  empresasf:[],   // [] lista       
  filialf:'', 
  filiaisf: [],   // [] lista   
  tipo:'',
  tipos:[],


/* objetos */
  kpiresumo:[],
  kpimkbf:[],
  kpiqtds:[],
  kpitipos:[],  
  kpidias:[],  
  kpifuncionario:[] ,
  kpilinha:[],
  kpicarro:[],
  seriestipo:[],
  seriesdia:[],
  seriesfuncionario:[],
  serieslinha:[],
  seriescarro:[],

  dt_inicial: '',
  dt_final: '',  

  sinistros:[],
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesfilial:[],  
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     

        }        
    },

    

    methods: {    
      
            loadEmpresas() {
              let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string             
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                           
            };
          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params}).then(res => {
            this.empresasf = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, nomeempresarial: emp.nomeempresarial }
            })
          })
      },  
      
      loadFiliais() {
              let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string             
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                           
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.get(url,{params}).then(res => {
            this.filiaisf = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
      },

      loadTipos() {
                    let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };
          const url = `${baseApiUrl}/manutencao/corretiva/tipo`  
          axios.post(url,corpo).then(res => {
            this.tipos = res.data.map(tp => {              
              return { ... tp, value:  tp.id, tipo: tp.tipo, sos: tp.sos }              
            })            
          })          
      },

      async loadKpiResumo() {
          let corpo = {    
                "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                                  
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,                                            
          };
          const url = `${baseApiUrl}/indicadores/abastecimento/resumo`
          axios.post(url,corpo)
            .then(res => {
              this.kpiresumo = res.data                              
            })
            .catch(showError)
      },

      async loadKpiMkbf() {
          let corpo = {    
                "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(at => at.id_filial_erp).join(', ')}`,                                                                                  
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
          };
          const url = `${baseApiUrl}/indicadores/corretiva/mkbf`
          axios.post(url,corpo)
            .then(res => {
              this.kpimkbf = res.data                              
            })
            .catch(showError)
      },


      /// qtd corretivas
      async loadKpiQtd() {
            let corpo = {    
               "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                           
                "tipo_id": `${this.tipo.map(f => f.id)}`,                                
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/qtd`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiqtds = res.data             
            })
            .catch(showError)
    },


      /// filtros por dia 
      async loadKpiDia() {
            let corpo = {    
               "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                           
                "tipo_id": `${this.tipo.map(f => f.id)}`,                                
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/periodo`
          axios.post(url,corpo)
            .then(res => {              
            this.kpidias = res.data 
            this.updateChartDataDia();               
            })
            .catch(showError)
    },
    
    async updateChartDataDia() {
      this.seriesdia = [{
        name: 'Qtd corretivas',
        data: this.kpidias.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdia.updateOptions({ xaxis:{
        categories: this.kpidias.map(d => d.dt_abertura)
      }  });       
    },

          /// filtros por tipo 
      async loadKpiTipo() {
            let corpo = {    
               "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                           
                "tipo_id": `${this.tipo.map(f => f.id)}`,                                
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/tipo`
          axios.post(url,corpo)
            .then(res => {              
            this.kpitipos = res.data 
            this.updateChartDataTipo();               
            })
            .catch(showError)
    },
    
    async updateChartDataTipo() {
      this.seriestipo = [{
        name: 'Qtd corretivas',
        data: this.kpitipos.map(item => parseInt(item.qtd)),
        }];
      this.$refs.charttipo.updateOptions({ xaxis:{
        categories: this.kpitipos.map(d => d.tipo)
      }  });       
    },


    /// filtros por operador 19/09/2023
      async loadKpiFuncionario() {
            let corpo = {    
               "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                           
                "tipo_id": `${this.tipo.map(f => f.id)}`,                                
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/operador`
          axios.post(url,corpo)
            .then(res => {              
            this.kpifuncionario = res.data 
            this.updateChartDataFuncionario();               
            })
            .catch(showError)
    },
    
    async updateChartDataFuncionario() {
      this.seriesfuncionario = [{
        name: 'Qtd sinistros',
        data: this.kpifuncionario.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncionario.updateOptions({ xaxis:{
        categories: this.kpifuncionario.map(r => r.operador)
      }  });       
    },

        /// filtros por operador 19/09/2023
      async loadKpiCarro() {
            let corpo = {    
               "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                           
                "tipo_id": `${this.tipo.map(f => f.id)}`,                                
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/carro`
          axios.post(url,corpo)
            .then(res => {              
            this.kpicarro = res.data 
            this.updateChartDataCarro();               
            })
            .catch(showError)
    },
    
    async updateChartDataCarro() {
      this.seriescarro = [{
        name: 'Qtd sinistros',
        data: this.kpicarro.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartcarro.updateOptions({ xaxis:{
        categories: this.kpicarro.map(r => r.carro)
      }  });       
    },

    /// filtros por operador 19/09/2023
    async loadKpiLinha() {
            let corpo = {    
               "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                           
                "tipo_id": `${this.tipo.map(f => f.id)}`,                                
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/linha`
          axios.post(url,corpo)
            .then(res => {              
            this.kpilinha = res.data 
            this.updateChartDataLinha();               
            })
            .catch(showError)
    },
    
    async updateChartDataLinha() {
      this.serieslinha = [{
        name: 'Qtd sinistros',
        data: this.kpilinha.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartlinha.updateOptions({ xaxis:{
        categories: this.kpilinha.map(r => r.linha)
      }  });       
    },












    },




    mounted(){
      this.loadEmpresas()
       
    },

    
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>